<template>
  <form
    class="form form--password-reset"
    method="post"
    @submit.prevent="submit"
  >
    <h1>Passwort zurücksetzen</h1>
    <div :class="formItemClasses('email')">
      <input
        class="form-element form--password-reset__email"
        type="text"
        name="email"
        placeholder="Benutzername/E-Mail"
        :disabled="!canSubmit()"
        v-model="email"
      />
    </div>
    <div
      class="form--password-reset__messages"
      v-if="message"
      v-html="message"
    ></div>
    <div class="form--password-reset__actions">
      <router-link class="password-reset-back" to="/login">zurück</router-link>
      <template v-if="!message">
        <LinkButton
          :icon-right="submitIcon"
          form="passwordReset"
          :text="str('login.resetPassword')"
        />
      </template>
    </div>
  </form>
</template>

<script>
  import util from '@/js/Util'
  import LinkButton from '@/components/LinkButton'

  export default {
    name: 'form-password-reset',
    data: () => {
      return {
        email: '',
      }
    },
    components: {
      LinkButton,
    },
    created() {
      if (!this.canSubmit()) {
        const message = this.str('authentication.passwordResetMailSent')
        this.$store.commit('setFormMessage', {
          form: 'passwordReset',
          message: message,
        })
      }
    },
    computed: {
      message() {
        return this.$store.getters.formMessage('passwordReset')
      },
      submitIcon() {
        return this.$store.getters.formState('passwordReset') !== 'finished'
          ? 'Arrow'
          : 'Check'
      },
    },
    methods: {
      formItemClasses: function (id) {
        let classes = ['form-item']
        if (this.focusedFormItem && this.focusedFormItem === id) {
          classes.push('form-item--focused')
        }
        return classes.join(' ')
      },
      submit() {
        if (this.email.length < 8) {
          return
        }
        this.$store.dispatch('startPasswordReset', this.email)
      },
      canSubmit() {
        const result = util.canDoPasswordReset()
        if (result) {
          this.$store.commit('setFormMessage', {
            form: 'passwordReset',
            message: false,
          })
        }
        return result
      },
    },
  }
</script>

<style lang="scss">
  .form--password-reset {
    max-width: 350px;
    margin-left: auto;
    margin-right: auto;
    transition: $transition-base;

    @media (min-height: 260px) {
      margin-top: 8vh;
    }

    @media (min-height: $bp-xs) {
      margin-top: 18vh;
    }

    &__messages {
      border: 2px solid $community;
      border-radius: $border-radius;
      line-height: $line-height-sm;
      padding: spacer(0.5) spacer(1);
      margin-bottom: spacer(1);
    }

    &__actions {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
  }

  .password-reset-back {
    cursor: pointer;
    transition: $transition-base;
  }
</style>
